import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cross",
  "use": "icon-cross-usage",
  "viewBox": "0 0 25 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 25 26\" id=\"icon-cross\">\n<path fill-rule=\"evenodd\" d=\"M25.020,23.606 L23.606,25.020 L13.000,14.414 L2.393,25.020 L0.979,23.606 L11.585,12.999 L0.979,2.393 L2.393,0.979 L13.000,11.585 L23.606,0.979 L25.020,2.393 L14.414,12.999 L25.020,23.606 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol